// Sticky Header
class StickyHeader extends HTMLElement {
    constructor() {
      super();

      window.userScroll = true;

      var hashAnchors = document.querySelectorAll('a[href^="#"]');
      if (hashAnchors.length > 0) {
        hashAnchors.forEach((anchor) => {
          anchor.addEventListener('click', () => {
            window.userScroll = false;
            if (document.querySelector('#shopify-section-header').classList.contains("shopify-section-header-hidden")) {
              document.querySelector('html').classList.add('scroll-padding-top-80');
              document.querySelector('html').classList.remove('scroll-padding-top-190');
            } else {
              document.querySelector('html').classList.remove('scroll-padding-top-80');
              document.querySelector('html').classList.add('scroll-padding-top-190');
            }
          })
        })
      }
    }
  
    /**
     * Calls when Component is Initialized in DOM
     *
     */
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
  
      this.onScrollHandler = this.onScroll.bind(this);
  
      window.addEventListener('scroll', this.onScrollHandler, false);
  
      this.createObserver();
    }
  
    /**
     * Calls when Component is removed from DOM
     *
     */
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    /**
     * To observe Sticky header visibility on User Scroll
     *
     */
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
  
      observer.observe(this.header);
    }
  
    /**
     * Window Scroll event
     *
     */
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    /**
     * Hide Sticky header
     * Close Menu Drawer / Seach Modal / Cart Drawer
     *
     */
    hide() {
      if (!window.userScroll) {
        setTimeout(function () {
          window.userScroll = true;
        }, 1000);
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
      this.closeMenuDropdowns();
      var productTabsApp = document.querySelector('.easytabs-holder .easytabs-tabs');
      var productTabs = document.querySelector('#productTabs .tabs-container.sticky-top');
      var filterWrapper = document.querySelector('#main-collection-filters.sticky-top');
      if (typeof(productTabs) != 'undefined' && productTabs != null){
        productTabs.style.top = 0;
      }
      if (typeof(productTabsApp) != 'undefined' && productTabsApp != null){
        productTabsApp.style.top = 0;
      }
      if (typeof(filterWrapper) != 'undefined' && filterWrapper != null){
        filterWrapper.style.top = 0;
      }
    }
  
    /**
     * Show Sticky Header
     *
     */
    reveal() {
      if (!window.userScroll) {
        setTimeout(function () {
          window.userScroll = true;
        }, 1000);
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      var productTabs = document.querySelector('#productTabs .tabs-container.sticky-top');
      var productTabsApp = document.querySelector('.easytabs-holder .easytabs-tabs');
      var filterWrapper = document.querySelector('#main-collection-filters.sticky-top');
      if (typeof(filterWrapper) != 'undefined' && filterWrapper != null){
        filterWrapper.style.top = document.querySelector('.site-header').offsetHeight + 'px';;
      }
      if (typeof(productTabs) != 'undefined' && productTabs != null){
        productTabs.style.top = document.querySelector('.site-header').offsetHeight + 'px';;
      }
      if (typeof(productTabsApp) != 'undefined' && productTabsApp != null){
        productTabsApp.style.top = document.querySelector('.site-header').offsetHeight + 'px';;
      }
    }
  
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  
    /**
     * Close Search Modal on Window Scroll
     *
     */
    closeSearchModal() {
      this.searchModal = this.searchModal || document.querySelector('search-modal');
      if(!this.searchModal) return;
      this.searchModal.close(false);
    }
  
    /**
     * Close Menu Dropdowns
     *
     */
    closeMenuDropdowns() {
      let openDropdowns = Array.from(document.querySelectorAll('.dropdown.open'));
      openDropdowns.forEach((ele) => {
        ele.classList.remove('open');
      });
    }
  }
  customElements.define('sticky-header', StickyHeader);